import { render, staticRenderFns } from "./vsSelectGroup.vue?vue&type=template&id=e3d354fc&"
import script from "./vsSelectGroup.vue?vue&type=script&lang=js&"
export * from "./vsSelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSelectGroup.vue"
export default component.exports